<template>
  <v-dialog v-model="dialog" max-width="500" width="auto">
    <v-card>
      <v-toolbar dense flat color="red-darken-3" dark>
        &nbsp; {{ title }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-col xs="12" cols="12">
          <v-row class="mt-2">
            <v-alert
              v-model="dialog"
              :type="type"
              variant="tonal"
              border="bottom"
            >
              {{ message }}
            </v-alert>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    value: false,
    message: null,
    title: null,
    type: "error",
    timeout: 5000,
  }),
  watch: {
    dialog(value) {
      if (!value) this.close();
    },
  },
  methods: {
    open(data) {
      this.dialog = true;
      this.title = data.title;
      this.message = data.message;
      if (data.type) this.type = data.type;
    },
    close() {
      this.dialog = false;
      this.message = null;
      this.type = "error";
    },
  },
};
</script>
